import { CommonModule } from '@angular/common'
import { ChangeDetectorRef, Component, Input } from '@angular/core'
import { RouterModule } from '@angular/router'
import { Subscription } from 'rxjs'
import { AngularMaterialsModules } from 'src/app/module/materials.module'
import { ThemeService } from 'src/app/service/theme/theme.service'
import { Themes } from '../../enums/enums'
@Component({
  selector: 'ddc-element-count',
  templateUrl: './ddc-element-count.component.html',
  styleUrl: './ddc-element-count.component.scss',
  imports: [AngularMaterialsModules, CommonModule, RouterModule],
})
export class DdcElementCountComponent {
  @Input('icon') _icon: string
  @Input('count') _count: string
  @Input('type') _type: string = null
  @Input('size') _size: string = null

  _isLightTheme: boolean = true
  _isDarkTheme: boolean = false
  _isPaperTheme: boolean = false
  private themeSubscription: Subscription

  constructor(
    public themeService: ThemeService,
    private cdr: ChangeDetectorRef,
  ) {
    this.themeSubscription = this.themeService.theme$.subscribe(theme => {
      this._isLightTheme = theme === Themes.LIGHT
      this._isDarkTheme = theme === Themes.DARK
      this._isPaperTheme = theme === Themes.PAPER
      this.cdr.markForCheck()
    })
  }
}
